import { render, staticRenderFns } from "./BudgetLiderModal.vue?vue&type=template&id=335bfea8&"
import script from "./BudgetLiderModal.vue?vue&type=script&lang=js&"
export * from "./BudgetLiderModal.vue?vue&type=script&lang=js&"
import style0 from "./BudgetLiderModal.vue?vue&type=style&index=0&id=335bfea8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports